import { render, staticRenderFns } from "./DashboardGoal.vue?vue&type=template&id=0ed2404c&"
import script from "./DashboardGoal.vue?vue&type=script&lang=js&"
export * from "./DashboardGoal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGoal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports